(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
  );

  const animatedSections = new Set();
  let frameRequested = false;

  function initializeReveals(root = document) {
    root.querySelectorAll('[data-td-reveal]:not([data-td-reveal-ready])').forEach((element) => {
      element.dataset.tdRevealReady = 'true';

      if (reducedMotion.matches) {
        element.classList.add('is-visible');
        return;
      }

      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.96) {
        requestAnimationFrame(() => element.classList.add('is-visible'));
      } else {
        revealObserver.observe(element);
      }
    });
  }

  function setStoryStep(story, index) {
    const cards = story.querySelectorAll('[data-td-story-step]');
    const images = story.querySelectorAll('[data-td-story-media]');
    const current = story.querySelector('[data-td-story-current]');

    cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === index));
    images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
    if (current) current.textContent = String(index + 1).padStart(2, '0');
  }

  function initializeStories(root = document) {
    root.querySelectorAll('[data-td-story]:not([data-td-story-ready])').forEach((story) => {
      story.dataset.tdStoryReady = 'true';
      const cards = Array.from(story.querySelectorAll('[data-td-story-step]'));
      if (!cards.length || reducedMotion.matches || window.matchMedia('(max-width: 749px)').matches) return;

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (!visible) return;
          setStoryStep(story, cards.indexOf(visible.target));
        },
        { rootMargin: '-30% 0px -42% 0px', threshold: [0, 0.2, 0.5, 0.8] }
      );

      cards.forEach((card) => observer.observe(card));
    });
  }

  function updateScrollMotion() {
    frameRequested = false;
    const viewportHeight = window.innerHeight;

    document.querySelectorAll('[data-td-parallax]').forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;
      const offset = Math.max(-18, Math.min(18, (viewportHeight * 0.5 - (rect.top + rect.height * 0.5)) * 0.045));
      element.style.setProperty('--td-parallax', `${offset}px`);
    });

    document.querySelectorAll('[data-td-how]').forEach((section) => {
      const rect = section.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (viewportHeight - rect.top) / Math.max(viewportHeight * 0.8, rect.height * 0.72)));
      section.style.setProperty('--td-progress', progress.toFixed(3));
    });
  }

  function requestScrollMotion() {
    if (frameRequested || reducedMotion.matches) return;
    frameRequested = true;
    requestAnimationFrame(updateScrollMotion);
  }

  function initializeMotion(root = document) {
    document.documentElement.classList.add('td-motion-ready');
    initializeReveals(root);
    initializeStories(root);

    root.querySelectorAll('[data-td-hero], [data-td-how]').forEach((section) => animatedSections.add(section));
    requestScrollMotion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeMotion());
  } else {
    initializeMotion();
  }

  window.addEventListener('scroll', requestScrollMotion, { passive: true });
  window.addEventListener('resize', requestScrollMotion, { passive: true });

  reducedMotion.addEventListener('change', () => {
    document.querySelectorAll('[data-td-reveal]').forEach((element) => element.classList.add('is-visible'));
    requestScrollMotion();
  });

  document.addEventListener('shopify:section:load', (event) => initializeMotion(event.target));
})();
